import EcoTextTc from 'eco-design/sections/eco-text-tc';
import { useRouter } from 'next/router';
import { RuleTabModuleIdEnum } from '../Tab';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

const highlightEmails = (text: string) => text.replace(/([\w.-]+@[\w-]+\.[\w.-]+)/g, '<span>$1</span>');

export default function Questions() {
    const { locale } = useRouter();
    const { t } = useLang('rule');

    const items = [
        {
            title: `<h3>${t('F_list_title1')}</h3>`,
            desc: highlightEmails(t('F_list_desc1')),
            isOpen: true,
        },
        {
            title: `<h3>${t('F_list_title2')}</h3>`,
            desc: highlightEmails(t('F_list_desc2')),
        },
        {
            title: `<h3>${t('F_list_title3')}</h3>`,
            desc: highlightEmails(t('F_list_desc3')),
        },
        {
            title: `<h3>${t('F_list_title4')}</h3>`,
            desc: highlightEmails(t('F_list_desc4')),
        },
        {
            title: `<h3>${t('F_list_title5')}</h3>`,
            desc: highlightEmails(t('F_list_desc5')),
        },
        {
            title: `<h3>${t('F_list_title6')}</h3>`,
            desc: highlightEmails(t('F_list_desc6')),
        },
    ];

    return (
        <div className={`${styles.questions} temp-part-6`} id={RuleTabModuleIdEnum.FrequentlyAskedQuestions}>
            <div className="text-container">
                <h2 className="title">{t('F_title')}</h2>
            </div>
            <EcoTextTc items={items} theme="white" className={locale} />
        </div>
    );
}
